import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/nominas-plazas-ipejal-percepcion/';

/**
 * GET IPEJAL Nominas Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIPEJALNominasPercepcionesPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET IPEJAL Nominas Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIPEJALNominasPercepciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET IPEJAL Nominas Percepciones
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIPEJALNominaPercepcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST IPEJAL Nominas Percepciones
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIPEJALNominaPercepcion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH IPEJAL Nominas Percepciones
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIPEJALNominaPercepcion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE IPEJAL Nominas Percepciones
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIPEJALNominaPercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR IPEJAL Nominas Percepciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIPEJALNominaPercepcion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
